import { useMemo, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Heading, Stack, HStack } from '@chakra-ui/react';
import { AddIcon, EditIcon } from '@chakra-ui/icons';
import { MdList } from 'react-icons/md';

import Button from 'components/v4/Button';
import AGGridMain from 'components/tables/AGGrid/AGGridMain';
import ActionsButton from 'components/tables/AGGrid/ActionsButton';
import { useGetOCProfiles } from './queries';
import { headingStyling } from 'components/forms/new/formStyles';

const OCProfilesTable = () => {
    const navigate = useNavigate();
    const gridRef = useRef();

    const {
        data: profiles,
        isLoading,
        isFetching,
        refetch,
    } = useGetOCProfiles();

    const columnDefs = useMemo(
        () => [
            {
                headerName: 'Operator Name',
                field: 'name',
                sort: 'asc',
            },
            {
                headerName: 'Carrier Name',
                field: 'carrierName',
            },
            {
                headerName: 'App ID',
                field: 'appID',
            },
            {
                headerName: 'Tenant ID',
                field: 'tenantID',
            },
            {
                headerName: 'Last Sync',
                field: 'lastSync',
            },
            {
                headerName: 'Action',
                field: 'action',
                maxWidth: 100,
                cellRenderer: (params) => {
                    const actions = [
                        {
                            label: 'Edit',
                            icon: EditIcon,
                            onClick: () =>
                                navigate(
                                    `/operator-connect-profiles/${params.data.id}`,
                                ),
                        },
                        {
                            label: 'View Operator Consents',
                            icon: MdList,
                            onClick: () =>
                                navigate(
                                    `/operator-connect-profiles/${params.data.id}?tab=consents`,
                                ),
                        },
                    ];
                    return <ActionsButton actions={actions} />;
                },
                filter: false,
                sortable: false,
            },
        ],
        [navigate],
    );

    const tableDataWithColumns = useMemo(
        () => ({
            columns: columnDefs,
            data: profiles || [],
        }),
        [profiles, columnDefs],
    );

    const handleAdd = () => {
        navigate('/operator-connect-profiles/add');
    };

    return (
        <Stack spacing={4}>
            <Heading sx={headingStyling}>Operator Profiles</Heading>
            <AGGridMain
                gridRef={gridRef}
                tableData={tableDataWithColumns}
                isLoading={isLoading}
                isFetching={isFetching}
                titleName="Operator Profiles"
                extraComponents={
                    <HStack pl={5} spacing={2}>
                        <Button
                            leftIcon={<AddIcon />}
                            size="sm"
                            onClick={handleAdd}>
                            OC Profiles
                        </Button>
                    </HStack>
                }
                refetch={refetch}
            />
        </Stack>
    );
};

export default OCProfilesTable;
